import { render } from "./MSubjectsRatioInput.vue?vue&type=template&id=42c05fe5"
import script from "./MSubjectsRatioInput.vue?vue&type=script&lang=ts"
export * from "./MSubjectsRatioInput.vue?vue&type=script&lang=ts"
script.render = render

export default script